import Mutations from '../../odata/mutations';

export default { ...new Mutations('reportAdjustment'), ...new Mutations('reportAdjustments') };
